module.exports = "https://static.wanderu.com/ui-react/_next/static/media/chiku.4cada793.svg";